module.exports = __webpack_public_path__ + "static/media/view-over-loch.a67153ee.png";